import { Inject, Injectable } from '@angular/core';
import { GTM, Gtm } from './gtm';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {
  private isInitialized = false;

  constructor(
    @Inject(GTM) private gtm: Gtm
  ) {}

  initAnalytics(trackingCode: string) {
    if (this.isInitialized) {
      return;
    }

    if (!this.gtm || !document) {
      return;
    }

    this.gtm({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });
    if (document !== undefined) {

      const s: HTMLScriptElement = document?.createElement('script');
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtm.js?id=${trackingCode}`;

      const head: HTMLHeadElement = document?.getElementsByTagName('head')[0];
      head.appendChild(s);

      this.isInitialized = true;
    }
  }

  page(path: string, title?: string) {
    try {
      const params = {
        event: 'page',
        pagePath: path
      };

      if (title) {
        params['pageTitle'] = title;
      }

      this.gtm(params);
    } catch (error) {
      console.log(error);
    }
  }
}
